import { ChangeDetectionStrategy, Component, Input, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IconButtonComponent } from '@examdojo/core/icon-button';
import { AngularSplitModule } from 'angular-split';

@Component({
  selector: 'exam-detail-view-wrapper',
  templateUrl: './detail-view-wrapper.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AngularSplitModule, IconButtonComponent],
  host: {
    class: 'flex h-full',
  },
})
export class DetailViewWrapperComponent {
  constructor(
    private readonly router: Router,
    private readonly activatedRoute: ActivatedRoute,
  ) {}

  @Input() backgroundColor = 'bg-neutral-50';

  readonly showSidebar = signal(false);

  readonly INITIAL_LEFT_NAV_WIDTH_PX = 300;
  readonly MIN_LEFT_NAV_WIDTH_PX = 300;
  readonly MAX_LEFT_NAV_WIDTH_PX = 300;

  goToListView() {
    // navigate to the parent route
    this.router.navigate(['..'], { relativeTo: this.activatedRoute });
  }
}
